'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WHITE = exports.WHITE = '#ffffff';

var GREEN = exports.GREEN = '#6cc551';
var GREEN_HOVER = exports.GREEN_HOVER = '#6ed14f';
var GREEN_ACTIVE = exports.GREEN_ACTIVE = '#5eb243';

var IDEAL_TEAL = exports.IDEAL_TEAL = '#00accc';
var IDEAL_TEAL_HOVER = exports.IDEAL_TEAL_HOVER = '#00b8d9';
var IDEAL_TEAL_ACTIVE = exports.IDEAL_TEAL_ACTIVE = '#00a1ba';
var TRUE_BLUE = exports.TRUE_BLUE = '#2b479e';

var COIN_YELLOW = exports.COIN_YELLOW = '#FFCB05';
var OPULENT_ORANGE = exports.OPULENT_ORANGE = '#FFA100';

var PRIMARY = exports.PRIMARY = GREEN;
var PRIMARY_HOVER = exports.PRIMARY_HOVER = GREEN_HOVER;
var PRIMARY_ACTIVE = exports.PRIMARY_ACTIVE = GREEN_ACTIVE;

var SECONDARY = exports.SECONDARY = IDEAL_TEAL;
var SECONDARY_HOVER = exports.SECONDARY_HOVER = IDEAL_TEAL_HOVER;
var SECONDARY_ACTIVE = exports.SECONDARY_ACTIVE = IDEAL_TEAL_ACTIVE;
var SECONDARY_2 = exports.SECONDARY_2 = TRUE_BLUE;

// greyscale

var CHARCOAL = exports.CHARCOAL = '#464646';
var DARK_GREY = exports.DARK_GREY = '#747679';
var MID_GREY = exports.MID_GREY = '#afafaf';
var COOL_GREY = exports.COOL_GREY = '#dcdcde';
var CLEAN_SLATE_GREY = exports.CLEAN_SLATE_GREY = '#f6f7f8';

// All fades of the same blue
var DARKEST_BLUE = exports.DARKEST_BLUE = '#0a74ad';
var DARKER_BLUE = exports.DARKER_BLUE = '#0d88cd';
var BLUE = exports.BLUE = '#0e95e0';
var LIGHTER_BLUE = exports.LIGHTER_BLUE = '#0f9eee';
var PALE_BLUE = exports.PALE_BLUE = '#a3d4e3';

var LIGHTER_GREEN = exports.LIGHTER_GREEN = '#6fd162';
var DARKER_GREEN = exports.DARKER_GREEN = '#519948';

var PURPLE = exports.PURPLE = '#56508b';

var LIGHTER_TEAL = exports.LIGHTER_TEAL = '#1bd1ad';
var DARKER_TEAL = exports.DARKER_TEAL = '#06a19b';
var DARKER_TEAL_2 = exports.DARKER_TEAL_2 = '#14997e';
var DARKEST_TEAL = exports.DARKEST_TEAL = '#048781';
var DARKEREST_TEAL = exports.DARKEREST_TEAL = '#036e68';

var RED = exports.RED = '#ff7043';
var AFRICAN_CORAL = exports.AFRICAN_CORAL = '#ff6e50';

var DARKEST_GREY = exports.DARKEST_GREY = '#464646';
var DARKER_GREY = exports.DARKER_GREY = '#929292';
var GREY = exports.GREY = '#bcbcbc';
var LIGHTER_GREY = exports.LIGHTER_GREY = '#dcdcdc';
var LIGHTEST_GREY = exports.LIGHTEST_GREY = '#f8f8f8';

// Validation Colors
var VALIDATION_GREEN = exports.VALIDATION_GREEN = PRIMARY;
var VALIDATION_RED = exports.VALIDATION_RED = RED;

// IPX Colors
var NORI_GREEN = exports.NORI_GREEN = '#64b498';
var NORI_GREEN_LIGHT = exports.NORI_GREEN_LIGHT = '#eff7f4';

var TWILIGHT_BLUE = exports.TWILIGHT_BLUE = '#004878';
var TWILIGHT_BLUE_LIGHT = exports.TWILIGHT_BLUE_LIGHT = '#ccdae4';
var TWILIGHT_BLUE_LIGHTEST = exports.TWILIGHT_BLUE_LIGHTEST = '#e5ecf1';

var RAINY_BLUE = exports.RAINY_BLUE = '#95d5ff';
var RAINY_BLUE_LIGHT = exports.RAINY_BLUE_LIGHT = '#e1f3ff';
var RAINY_BLUE_LIGHTEST = exports.RAINY_BLUE_LIGHTEST = '#f4faff';

var CREAM_PINK = exports.CREAM_PINK = '#ffc2bc';
var CREAM_PINK_LIGHT = exports.CREAM_PINK_LIGHT = '#fff2f1';
var CREAM_PINK_LIGHTEST = exports.CREAM_PINK_LIGHTEST = '#fff8f8';

var HONEY_GOLD = exports.HONEY_GOLD = '#ffb809';
var HONEY_GOLD_LIGHT = exports.HONEY_GOLD_LIGHT = '#fff0cd';
var HONEY_GOLD_LIGHTEST = exports.HONEY_GOLD_LIGHTEST = '#fff7e6';

var SALMON = exports.SALMON = '#ffaf83';
var SALMON_LIGHT = exports.SALMON_LIGHT = '#ffefe6';
var SALMON_LIGHTEST = exports.SALMON_LIGHTEST = '#fff7f2';

var GREEN_MEDIUM = exports.GREEN_MEDIUM = '#def4db';
var GREEN_LIGHT = exports.GREEN_LIGHT = '#e9f9eb';

// deprecated colors that should not be used (but are here for backwards compatibility)

var LAVENDER = exports.LAVENDER = '#ad94fa';
var LAVENDER_MEDIUM = exports.LAVENDER_MEDIUM = '#eee4ff';
var LAVENDER_LIGHT = exports.LAVENDER_LIGHT = '#f8f4ff';

var PEACH_PINK = exports.PEACH_PINK = '#ff83a7';
var PEACH_PINK_MEDIUM = exports.PEACH_PINK_MEDIUM = '#ffe4ee';
var PEACH_PINK_LIGHT = exports.PEACH_PINK_LIGHT = '#fff0f6';

var IDEAL_TEAL_MEDIUM = exports.IDEAL_TEAL_MEDIUM = '#c5eff6';
var IDEAL_TEAL_LIGHT = exports.IDEAL_TEAL_LIGHT = '#e2f7f9';

var TRUE_BLUE_MEDIUM = exports.TRUE_BLUE_MEDIUM = '#d4daed';
var TRUE_BLUE_LIGHT = exports.TRUE_BLUE_LIGHT = '#e9ecf6';

var CORAL = exports.CORAL = '#ff634b';
var CORAL_MEDIUM = exports.CORAL_MEDIUM = '#ffdcda';
var CORAL_LIGHT = exports.CORAL_LIGHT = '#ffedec';